module.exports = __webpack_public_path__ + "static/img/game-img-dg.834cc2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/game-img-dg.png
// module id = 2HJ5
// module chunks = 0